import {HostListener} from '@angular/core';
import {NavigationService} from '../services/navigation/navigation.service';
import {BaseActions} from '../shared/base-actions';
import {Subject} from 'rxjs';
import {KeyDirections} from '../shared/key-directions.enum';

export class NavigableComponent extends BaseActions {
  lastPressed: Date = new Date();
  allowedPressesPerSecond = 4;
  vhValue = 0;
  escapePressed = new Subject<boolean>();
  playPressed = new Subject<boolean>();
  forwardPressed = new Subject<boolean>();
  rewindPressed = new Subject<boolean>();
  playPressedOnKeyBoard = new Subject<boolean>();
  fastForwardPressedOnKeyBoard = new Subject<boolean>();
  backwardPressedOnKeyBoard = new Subject<boolean>();


  constructor(protected navigationService: NavigationService) {
    super();
  }

  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    const now = new Date();
    if ((now.getTime() - this.lastPressed.getTime()) / 1000 > 1 / this.allowedPressesPerSecond) {
      this.lastPressed = now;
      this.handleVideoEvents(event);
      this.navigationService.navigate(event.keyCode);
      this.vhValue = this.navigationService.state.vhValue;
    }
  }
  private handleVideoEvents(event: KeyboardEvent): void {
    this.handleKeyEvent(event, KeyDirections.ESCAPE, this.escapePressed);
    this.handleKeyEvent(event, KeyDirections.PLAY_PAUSE, this.playPressed);
    this.handleKeyEvent(event, KeyDirections.FORWARD, this.forwardPressed);
    this.handleKeyEvent(event, KeyDirections.REWIND, this.rewindPressed);
    this.handleKeyEvent(event, KeyDirections.PLAY_PAUSE_ON_KEYBOARD, this.playPressedOnKeyBoard);
    this.handleKeyEvent(event, KeyDirections.FAST_FORWARD_ON_KEYBOARD, this.fastForwardPressedOnKeyBoard);
    this.handleKeyEvent(event, KeyDirections.REWIND_ON_KEYBOARD, this.backwardPressedOnKeyBoard);
  }

  private handleKeyEvent(event: KeyboardEvent, direction: KeyDirections, subject: Subject<boolean>): void {
    if (event.keyCode === direction) {
      subject.next(true);
    } else {
      subject.next(false);
    }
  }
}
